import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

// Lands here from the `setup` Checkout Session's success_url (see
// routes/subscriptions.js) — the card is saved, and the webhook has (or is
// about to) mark the new Subscriptions row(s) ACTIVE. No status polling yet:
// the webhook runs within moments of this redirect, so this just confirms
// the card step completed rather than waiting on Airtable to catch up.
export default function SubscriptionConfirmationPage() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');

  return (
    <div className="sf-flow-page sf-sub-page">
      <h1 className="sf-sub-page__title">You&apos;re all set</h1>
      <p className="sf-sub-page__subtitle">
        Your card is saved and your subscription is active. We&apos;ll charge
        it weekly, after your edit deadline, only for the meals you keep —
        skip a week and you won&apos;t be charged for it.
      </p>
      {sessionId && (
        <p className="sf-sub-section__hint">Reference: {sessionId}</p>
      )}
      <Link to="/" className="sf-sub-page__submit" style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}>
        Back to home
      </Link>
    </div>
  );
}
